var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F55060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 8.6V5.61m0 5.206v.027m3.78 2.49H4.22a2.266 2.266 0 0 1-2.178-1.616c-.117-.399.027-.814.247-1.167l3.78-6.816c.885-1.423 2.977-1.423 3.863 0l3.78 6.816c.22.353.363.768.246 1.167a2.265 2.265 0 0 1-2.178 1.616Z"
  })));
};
export default SvgAlert;